import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import tmdbLogo from '../../assets/tmdb-logo.svg';

const LEGAL_LINKS = [
  { label: 'Terms and Conditions', to: '/terms' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Cookie Policy', to: '/cookie-policy' },
  { label: 'Disclaimer', to: '/disclaimer' },
] as const;

export function LegalSection() {
  return (
    <div className="bg-[#1A1F26] rounded-xl p-6">
      <h2 className="text-lg font-semibold text-white mb-4">LEGAL</h2>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {LEGAL_LINKS.map(({ label, to }) => (
          <Link
            key={to}
            to={to}
            className="text-sm text-slate-400 hover:text-white transition-colors inline-flex items-center gap-1"
          >
            {label}
            <ChevronRight size={12} />
          </Link>
        ))}
      </div>
      <div className="mt-4 text-sm leading-6 text-slate-400">
        <p className="font-medium text-slate-300">Filmpl LLC</p>
        <p>16192 Coastal Highway</p>
        <p>Lewes, DE 19958</p>
        <p>United States</p>
      </div>
      <div className="mt-4 flex items-center gap-3">
        <img src={tmdbLogo} alt="TMDB" className="h-3" />
        <p className="text-xs text-slate-500">
          This product uses the TMDB API but is not endorsed or certified by TMDB.
        </p>
      </div>
    </div>
  );
}
